import CourseGuide from '@components/LocalMerchant/Common/CourseGuide'
import { MARKETING_CENTER_PATH } from '@constant'
import { RouterView } from '@merchant-backend/common-components'
import { getMerchantInfo, isStoreAccount } from '@util'
import { Button } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import { Link } from 'react-router'
import styles from '../style.module.less'
import Intro from './Intro'
import SearchTable from './SearchTable'
import SearchTableStore from './SearchTable/store'
import SideBar from './SideBar'

@observer
export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new SearchTableStore()
    // todo，优惠券页面有两次请求
    this.store.$getList()
  }

  getExtra = () => {
    const { is_special_merchant } = getMerchantInfo()
    const { show, more, toEdit } = this.store

    return show && more && is_special_merchant !== 2 ? (
      <Button
        type="primary"
        onClick={toEdit()}
        style={{ height: 32, width: 100, fontSize: 14 }}
      >
        创建优惠券
      </Button>
    ) : null
  }

  render() {
    const { is_special_merchant } = getMerchantInfo()
    const { show, more } = this.store

    return (
      <RouterView
        title="优惠券"
        header={
          isStoreAccount()
            ? [<Link to={MARKETING_CENTER_PATH}>营销工具</Link>, '优惠券']
            : ''
        }
        extra={this.getExtra()}
        sideBar={<SideBar />}
      >
        {this.props.location.state?.guide && (
          <CourseGuide taskId="11" otherGuide={true} />
        )}
        <div className={styles.brief}>
          {(is_special_merchant == 1 || is_special_merchant == 2) && (
            <p style={{ marginBottom: 10, fontSize: 14 }}>
              <i className={styles.attention}>i</i>
              {is_special_merchant == 1 && (
                <span>您的设置和修改将同步至所有的店铺，子店铺无法修改</span>
              )}
              {is_special_merchant == 2 && (
                <span>
                  您无法修改当前设置，系统将默认认为您同步主门店的相关设置
                </span>
              )}
            </p>
          )}

          {show && !more && <Intro />}

          {show && more && <SearchTable store={this.store} />}
        </div>
      </RouterView>
    )
  }
}
